/* eslint-disable import/prefer-default-export */
export const SEASON_ACTION_TYPES = {
  SET_SELECTED_SEASON: 'season/SET_SELECTED_SEASON',
};
